import axios from 'axios'
import * as FIELD_CONSTANTS from '../mappings/FIELD_CONSTANTS'
import DemandBase from './DemandBase'
import GeoNames from './GeoNames'
import MarketoMunchkin from './MarketoMunchkin'
import PreFill from '../helpers/prefill'
import CampaignHierarchy from '../helpers/campaignHierarchy'


export class SmartForm {

    constructor(obj, forceUpdate) {
        this.data = obj
        this.forceUpdate = forceUpdate
        this.geoNamesApi = GeoNames

        //merge the utm field list with the demand base field list
        let supp_lists = FIELD_CONSTANTS.FIELD_GOOGLE_SUPP_LIST
        this.data.fields = Object.assign(obj.form, supp_lists.reduce(function(newObj, item){
            newObj[item] = ""
            return newObj
        }, {}))
        this.demandBase = {}
        this.marketoMunchkin = {}

        this.data.defaults = {
            "programName" : obj.defaults.programName,
            "Record_Processing_Type__c" : obj.defaults.type,
            "InteractionStage" : 2,
            "reason" : "Manual Import or Remote POST",
            "leadStatus": "B",
            "lookupField": "email",
            "source": "MarTel Slug: [smart-form]",
            "Registration_Date__c" : new Date().toISOString().substring(0, 10),
            "referrerURL" : document.referrer,
            "userAgent" : navigator.userAgent,
            "webPage" : window.location.href
        }

        this._init()
    }

    /**
     * Assign default values and states
     * @private
     */
    _setDefaults() {
        Object.assign(this.data.fields, this.data.defaults)

        //hide these to start with, will show based on country selection
        this.hideField("state")
        this.hideField("postalCode")
        this.hideField("Email_Blast_OK__c")
        this.hideField("OK_to_Call__c")

        //temporary, causing martel validator to fail if this has a blank value
        delete this.data.fields["GEOContactEmail"]
    }

    /**
     * Return if field visible in the dom
     * @param field
     * @returns {*}
     */
    isVisible(field){
        return this.data.schema.config[field].show
    }

    /**
     * show a specific field
     * @param field
     */
    showField(field){
        this.data.schema.config[field].show = true
    }

    /**
     * hide a specific field
     * @param field
     */
    hideField(field){
        this.data.schema.config[field].show = false
    }

    /**
     * Removed embargoes countries from country list
     * @private
     */
    _handleEmbargoedCountries(){
        for(let el in this.data.schema.config.country.options){
            if(FIELD_CONSTANTS.EMBARGOED_COUNTRIES.includes(this.data.schema.config.country.options[el])){
                delete this.data.schema.config.country.options[el]
            }
        }
    }

    /**
     * Loop through Primary_Product_Interest__c array and match old products names to new ones
     * @private
     */
    _checkPPI(){
        let newPPIMap = []
        for (let field in this.data.fields.Primary_Product_Interest__c){
            let item = this.data.fields.Primary_Product_Interest__c[field]
            if(item in FIELD_CONSTANTS.PPI_MAP){
                newPPIMap.push(FIELD_CONSTANTS.PPI_MAP[item])
            }else{
                newPPIMap.push(item)
            }
        }
        this.data.fields.Primary_Product_Interest__c = newPPIMap
    }

    /**
     * Will show an APJ specific privacy message if country matches apj privacy list
     * @private
     */
    _checkAPJPrivacy(){
        this.data.status.apjPrivacy = (FIELD_CONSTANTS.APJ_PRIVACY_COUNTRIES.includes(this.data.fields.country))
    }

    /**
     * Series of checks for GDPR specific business cases
     *
     * @private
     */
    _checkGDPR(){
        let isGDPR = (FIELD_CONSTANTS.GDPR_COUNTRIES.includes(this.data.fields.country))

        if(isGDPR) {
            // only show the email ok if not pre-filled with yes
            if (this.data.fields.Email_Blast_OK__c !== 'Yes') {
                this.showField("Email_Blast_OK__c")
            }
            if ((this.data.fields.Sales_Contact_Requested__c === 'Yes' || this.isVisible("phone")) && this.data.fields.OK_to_Call__c !== 'Yes') {
                this.showField("OK_to_Call__c")
                if (this.isVisible("phone") && this.data.fields.OK_to_Call__c === 'No') {
                    this.hideField("phone")
                }
            }
        }else{
            if(this.isVisible("country") && this.data.fields.Email_Blast_OK__c === 'No'){
                this.showField("Email_Blast_OK__c")
            }else if(!this.isVisible("country")){
                this.hideField("Email_Blast_OK__c")
            }
            if(this.isVisible("phone") && this.data.fields.OK_to_Call__c === 'No'){
                this.showField("OK_to_Call__c")
            }else if(!this.isVisible("phone")){
                this.hideField("OK_to_Call__c")
            }
        }

        this.data.status.gdpr = isGDPR
    }

    /**
     * hide/show the state dropdown if there are states to be populated
     *
     * @param list
     * @private
     */
    _toggleStateMenu(list){
        (list) ? this.showField("state") : this.hideField("state")
    }

    /**
     *
     */
    initCampaignHierarchy(){
        // helper will handle logic
        CampaignHierarchy.updateFields(this.data.fields)
    }

    /**
     * initialize DemandBase
     */
    initDemandBase(){
        this.demandBase = new DemandBase({fields:this.data.fields, status:this.data.status, prefillData: this.data.prefillData}, this.forceUpdate, this.data.settings)
    }

    /**
     * Called on blur of postalCode field
     */
    handleGeoNames(){
        this.geoNamesApi(this.data.fields.postalCode, this.data.fields.country, this.doGeoNames, this)
    }

    /**
     * Populate fields with geonames lookup data
     *
     * @param data
     * @param self
     */
    doGeoNames(data, self){
        if (data.postalCodes !== null && data.postalCodes !== '') {
            let postalcode = data.postalCodes[0]
            self.data.fields.state = postalcode.adminCode1
            self.data.fields.city = postalcode.placeName
            self.data.schema.config.state.show = true
        }else{
            self.data.fields.city = ""
            self.data.fields.state = ""
            self.data.schema.config.state.show = true
        }
        self.forceUpdate()
    }

    /**
     * Stringify array data before submission and any other cleanup
     *
     * @param data
     * @returns {*}
     */
    cleanSubmissionData(data){

        //remove any script tags
        data = JSON.stringify(data).replace(/<\/?[^>]+>/gi, '')
        data = JSON.parse(data)

        // primary product interest needs to be string
        data.Primary_Product_Interest__c = data.Primary_Product_Interest__c.join(";");

        // remove all non numeric characters from the phone number
        data.phone = (data.phone) ? data.phone.replace( /\D+/g, '') : ""

        //remove new line characters from comments
        data.Comments__c = data.Comments__c.replace(/(\r\n|\n|\r)/gm, " ");

        return data
    }


    /**
     * Perform initializations if enabled
     */
    initLoader(){

        if(this.data.settings.marketoMunckinEnabled){
            //add marketo value to field list
            Object.assign(this.data.fields, FIELD_CONSTANTS.MKTO_SUPP_LIST)

            //init munchkin script and tracker
            this.marketoMunchkin = new MarketoMunchkin(this.data.fields)
        }

        this._checkPPI()
        this._handleEmbargoedCountries()
        this._checkGDPR()

    }

    /**
     * Populate with passed data, otherwise load from ctx_sf_data localStorage
     *
     * @param data
     */
    prefill(data) {

        if(data){
            Object.assign(this.data.fields, data)
        }else{
            if(this.data.settings.prefillEnabled) {
                let storeObj = PreFill.get()
                if (storeObj) {
                    this.data.prefillData = storeObj
                    Object.assign(this.data.fields, this.data.prefillData)
                    this.data.status.prefilled = true
                }
            }
        }
        this._checkPPI()

    }

    /**
     * Remove the field exclusions and save the submitted data into local storage.
     *
     * @param data
     */
    setPrefill(data){

        let dataCopy = Object.assign({}, data)
        FIELD_CONSTANTS.PREFILL_EXCLUSIONS.forEach(function(item){
            delete dataCopy[item]
        })
        PreFill.set(dataCopy)

    }

    /**
     * Returns list of states assigned to country.
     *
     * @param country
     * @returns {*}
     */
    getStateList(country){
        let list = this.data.schema.states[country]
        this._toggleStateMenu(list)
        return list
    }

    /**
     * Fires multiple events/checks when country is switched.
     *
     * @param country
     */
    handleCountrySwitch(country){

        // hide postalcode is doesnt apply to selected country
        (FIELD_CONSTANTS.COUNTRIES_WITH_ZIP.includes(country)) ? this.showField("postalCode") : this.hideField("postalCode")

        // replace state options with that of selected country
        this.data.schema.config.state.options = this.getStateList(country)

        this._checkGDPR()
        this._checkAPJPrivacy()

        this.forceUpdate()
    }

    /**
     * show/hide phone when OK_to_Call__c changed.
     *
     * @param val
     */
    handlePhoneOKSwitch(val){
        if(val === 'Yes') {
            this.showField("phone")
        }else if(this.isVisible("phone") && val === 'No'){
            this.hideField("phone")
        }
    }

    /**
     * Perform demandbase domain lookup on email field blur.
     *
     * @param val
     */
    handleEmailChange(val){
        if(this.data.settings.demandbaseEnabled){
            this.demandBase.DemandbaseDomainQuery(val)
        }
    }

    /**
     *  TODO: may need nothing
     */
    handlePhoneChange(val){
        if(this.data.settings.demandbaseEnabled){
            //this.demandBase.updateValue("phone_change", true)
        }
    }

    /**
     * show/hide phone field based on Hot_HaveSalesContactMe
     * @param val
     */
    handleSalesContactChange(val){
        if(this.data.status.gdpr){
            this.showField("OK_to_Call__c")
        }
        (val === "Yes") ? this.showField("phone") : this.hideField("phone")
    }

    /**
     *
     * @param errors
     */
    handleErrors(errors){
        let errorStatus = false
        let errorFields = function(){
            let arr = []
            for(let i in errors.items){
                arr.push(errors.items[i].field)
            }
            return arr
        }

        for(let field in this.data.schema.config){
            errorStatus = (errorFields().includes(field)) ? true : false
            this.data.schema.config[field].stateClass.error = errorStatus
        }

    }

    /**
     * process errors for GA event tracking
     * @param errors
     * @returns {*}
     */
    processErrorsForGA(errors){
        if(errors.items.length > 0){

            let errorObj = {}

            errors.items.forEach(function(item){
                errorObj[item.field] = {
                    'error' : item.rule,
                    'message' : item.msg
                }
            })

            let obj = {
                'template' : this.data.config.template,
                'errors' : errorObj
            }

            return JSON.stringify(obj)

        }

        return false
    }

    /**
     *  Check all the fields to determine if a value is present, handles label placement
     */
    updateFieldStates(){
        let hasValue = false
        for(let field in this.data.schema.config){
            hasValue = (this.data.fields[field] == "") ? false : true
            this.data.schema.config[field].stateClass.hasValue = hasValue
        }

    }

    /**
     *  clear fields that aren't in the pre-fill exclusion list, remove pre-fill local storage item
     */
    resetForm(){
        for(let field in this.data.fields){
            if(!FIELD_CONSTANTS.PREFILL_EXCLUSIONS.includes(field)){
                this.data.fields[field] = ""
            }
        }
        PreFill.unset()
    }

    /**
     * Post the form data to the Martel endpoint.
     *
     * @param endpoint
     * @param data
     * @param callback
     */

    sendData(endpoint, data, callback){
        axios({
            method: 'post',
            url: endpoint,
            data: data
        }).then(function (response) {
            callback({
                "status":response.status,
                "statusText":response.statusText
            })
        }).catch(function(e){
            console.log('___ERROR____')
            console.log(e)
            console.log("___________")
            callback({
                "status":e.response.status,
                "statusText":"Network Error"
            })
        })
    }

    /**
     * set the defaults and initialize the loader
     *
     * @private
     */
    _init() {
        this._setDefaults()
        this.initLoader()
    }

}